import { editInfluencerExample, fetchInfluencerExamples, revertInfluencerExample } from './asyncThunks';

export const fetchInfluencerExamplesBuilder = builder => {
  builder.addCase(fetchInfluencerExamples.pending, (state, { meta }) => {
    const page = meta.arg.page;
    if (page === 1) {
      state.fetchInfluencerExamplesInfo.pending = true;
    } else {
      state.fetchInfluencerExamplesInfo.fetchMorePending = true;
    }
  });
  builder.addCase(fetchInfluencerExamples.fulfilled, (state, { payload }) => {
    const { data, maxReached, page } = payload;
    if (page === 1) {
      state.fetchInfluencerExamplesInfo.data = data;
      state.fetchInfluencerExamplesInfo.pending = false;
    } else {
      state.fetchInfluencerExamplesInfo.fetchMorePending = false;
      state.fetchInfluencerExamplesInfo.data = [...state.fetchInfluencerExamplesInfo.data, ...data];
    }
    state.fetchInfluencerExamplesInfo.maxReached = maxReached;
  });
  builder.addCase(fetchInfluencerExamples.rejected, state => {
    state.fetchInfluencerExamplesInfo.pending = false;
    state.fetchInfluencerExamplesInfo.fetchMorePending = false;
  });
};

export const editInfluencerExampleBuilder = builder => {
  builder.addCase(editInfluencerExample.pending, state => {
    state.pending.editInfluencerExample = true;
  });
  builder.addCase(editInfluencerExample.fulfilled, (state, { payload }) => {
    const { influencerExample } = payload;
    state.pending.editInfluencerExample = false;
    state.fetchInfluencerExamplesInfo.data = state.fetchInfluencerExamplesInfo.data.map(e =>
      e._id === influencerExample._id ? influencerExample : e,
    );
  });
  builder.addCase(editInfluencerExample.rejected, state => {
    state.pending.editInfluencerExample = false;
  });
};

export const revertInfluencerExampleBuilder = builder => {
  builder.addCase(revertInfluencerExample.pending, state => {
    state.pending.revertInfluencerExample = true;
  });
  builder.addCase(revertInfluencerExample.fulfilled, (state, { payload }) => {
    const { influencerExample } = payload;
    state.pending.revertInfluencerExample = false;
    state.fetchInfluencerExamplesInfo.data = state.fetchInfluencerExamplesInfo.data.map(e =>
      e._id === influencerExample._id ? influencerExample : e,
    );
  });
  builder.addCase(revertInfluencerExample.rejected, state => {
    state.pending.revertInfluencerExample = false;
  });
};
